// tlx-carousel.js
(() => {
  const SELECTOR_ROOT = '[data-tlx]';
  const SELECTOR_ITEM = '[data-tlx-item]';
  const SELECTOR_TABS = '[data-tlx-nav] button';

  const initSection = (root) => {
    if (!root || root.__tlx_inited) return;

    const items = [...root.querySelectorAll(SELECTOR_ITEM)];
    const tabs  = [...root.querySelectorAll(SELECTOR_TABS)];
    const nav   = root.querySelector('[data-tlx-nav]');
    if (!items.length) return;

    let index = 0;

    const alignTab = () => {
      if (!nav || !tabs[index]) return;
      // 選択タブをナビ内で中央付近に
      tabs[index].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };

    // skipAlign=true の場合は初期化時にスクロールしない
    const select = (i, focusTab=false, skipAlign=false) => {
      index = (i + items.length) % items.length;

      // 既存のアクティブを外す → 新規に付与（CSS keyframesが毎回発火）
      items.forEach((el, idx) => el.classList.toggle('is-active', idx === index));
      tabs.forEach((b, idx) => b && b.setAttribute('aria-current', idx === index ? 'true' : 'false'));

      if (focusTab && tabs[index]) tabs[index].focus();
      if (!skipAlign) alignTab();
    };

    tabs.forEach((b, i) => b && b.addEventListener('click', () => select(i)));

    // キー操作
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') select(index + 1, true);
      if (e.key === 'ArrowLeft')  select(index - 1, true);
    });

    // 簡易スワイプ
    let sx = null;
    root.addEventListener('pointerdown', e => sx = e.clientX);
    root.addEventListener('pointerup', e => {
      if (sx === null) return;
      const dx = e.clientX - sx;
      if (dx > 40)  select(index - 1);
      if (dx < -40) select(index + 1);
      sx = null;
    });

    // 初期表示 → alignTab をスキップ
    select(0, false, true);
    root.__tlx_inited = true;
    console.log('[tlx] inited section:', root);
  };

  const initAll = () => document.querySelectorAll(SELECTOR_ROOT).forEach(initSection);
  const safeInit = () => requestAnimationFrame(() => setTimeout(initAll, 50));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit, { once: true });
  } else {
    safeInit();
  }
  window.addEventListener('load', safeInit);

  // Shopify editor / 再描画など
  document.addEventListener('shopify:section:load', safeInit);
  document.addEventListener('shopify:section:reorder', safeInit);
  document.addEventListener('shopify:inspector:dom:ready', safeInit);
  ['page:load','swup:contentReplaced','turbo:load','astro:after-swap'].forEach(ev =>
    document.addEventListener(ev, safeInit)
  );

  // 動的挿入の保険
  new MutationObserver(() => safeInit()).observe(document.documentElement, { childList: true, subtree: true });
})();
